/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteSectorCommand } from '../../models/delete-sector-command';
import { DeleteSectorCommandResult } from '../../models/delete-sector-command-result';

export interface ApiSectorDeleteSectorDelete$Plain$Params {
      body?: DeleteSectorCommand
}

export function apiSectorDeleteSectorDelete$Plain(http: HttpClient, rootUrl: string, params?: ApiSectorDeleteSectorDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteSectorCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiSectorDeleteSectorDelete$Plain.PATH, 'delete');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeleteSectorCommandResult>;
    })
  );
}

apiSectorDeleteSectorDelete$Plain.PATH = '/api/Sector/DeleteSector';
